import { enableBodyScroll, disableBodyScroll } from "body-scroll-lock";

// Elements
const htmlElement = document.documentElement;

// Get a target element that you want to persist scrolling for (such as a modal/lightbox/flyout/nav). Specifically, the target element is the one we would like to allow scroll on (NOT a parent of that element). This is also the element to apply the CSS '-webkit-overflow-scrolling: touch;' if desired.
const siteHeader = document.querySelector('.jsSiteHeader');
const siteNav = document.querySelector('.jsSiteNav');
const mobileNavToggle = document.querySelector('.jsMobileNavToggle');
const siteOverlayMobile = document.querySelector('.jsSiteOverlayMobile');
const siteOverlayDesktop = document.querySelector('.jsSiteOverlayDesktop');

const breakpoint = "(min-width: 1024px)";
const mediaQuery = window.matchMedia(breakpoint);

// function handleResize(mediaQuery)
// {
// 	if (!mediaQuery.matches)
// 	{
// 		console.log("Viewport is smaller than or equal to the breakpoint");
// 		// Your code for smaller viewport
// 	}
// 	else
// 	{
// 		console.log("Viewport is larger than the breakpoint");
// 		// Your code for larger viewport
// 	}
// }

// handleResize(mediaQuery);
// mediaQuery.addEventListener("change", handleResize);

// Watch things for interaction.
export function mobileNavWatch()
{
	mobileNavToggle.addEventListener('click', toggleMobileNav);

	// Close menu if ESC is pressed
	document.addEventListener('keyup', function (e)
	{
		if (e.key == "Escape")
		{
			closeMobileNav();
		}
	});
}

function toggleMobileNav()
{
	const mobileNavState = htmlElement.classList.toggle('mobile-nav-open');
	if (mobileNavState)
	{
		disableBodyScroll(siteNav)
		siteOverlayMobile.addEventListener('click', closeMobileNav);
	}
	else
	{
		enableBodyScroll(siteNav)
		siteOverlayMobile.removeEventListener('click', closeMobileNav);
	}
}

function closeMobileNav()
{
	htmlElement.classList.remove('mobile-nav-open');
	enableBodyScroll(siteNav);
}

/*
----------------------------------------------------------------------
Mega Menus
----------------------------------------------------------------------
*/
export function submenuToggle()
{
	let submenuToggles = document.querySelectorAll('.jsSubmenuToggle');
	submenuToggles.forEach(submenuToggle =>
	{
		submenuToggle.addEventListener('click', (e) =>
		{
			handleSubmenuToggle(e.target);
		});
	});
}

function closeMegamenu()
{
	htmlElement.classList.remove('megamenu-open');
	enableBodyScroll(siteHeader);
	document.querySelector('.is-parent.is-open').classList.remove('is-open')
}

function handleSubmenuToggle(el)
{
	let parentSubmenu = el.closest('.is-parent');
	let siblingSubmenus = el.closest('ul').querySelectorAll('.is-parent');

	const parentSubmenuState = parentSubmenu.classList.toggle('is-open');

	// If we're at desktop sizes, we're dealing with a mega-menu
	if (mediaQuery.matches)
	{
		if (parentSubmenuState)
		{
			disableBodyScroll(siteHeader);
			siteOverlayDesktop.addEventListener('click', closeMegamenu);
			htmlElement.classList.add('megamenu-open');
		}
		else
		{
			enableBodyScroll(siteHeader);
			siteOverlayDesktop.removeEventListener('click', closeMegamenu);
			htmlElement.classList.remove('megamenu-open');
		}

		parentSubmenuState ? disableBodyScroll(siteHeader) : enableBodyScroll(siteHeader);
	}

	siblingSubmenus.forEach(sibling =>
	{
		if (sibling != parentSubmenu)
		{
			sibling.classList.remove('is-open');
		}
	});
}